import { BuilderConfig } from '../../../types/Builder';
import ArticleThumbnails, { Props } from './article-thumbnails';

export const FlowCarouselHeaderBuilderConfig = {
  name: 'Article thumbnails',
  inputs: [
    {
      name: 'currentArticleTitle',
      type: 'string',
      defaultValue: '',
    },
    {
      name: 'articles',
      type: 'list',
      defaultValue: [],
      required: true,
      subFields: [
        {
          name: 'title',
          type: 'string',
          defaultValue: '',
          required: true,
        },
        {
          name: 'description',
          type: 'richText',
          defaultValue: '',
          required: true,
        },
        {
          name: 'articleUrl',
          type: 'string',
          defaultValue: '',
        },
        {
          name: 'leadImage',
          type: 'file',
          defaultValue: '',
          required: true,
        },
        {
          name: 'categories',
          type: 'list',
          defaultValue: [],
          required: true,
          subFields: [
            { name: 'name', defaultValue: '', type: 'string', required: true },
            { name: 'url', type: 'string', defaultValue: '' },
          ],
        },
      ],
    },
  ],
};

const builderConfig: BuilderConfig<Props> = {
  component: ArticleThumbnails,
  config: FlowCarouselHeaderBuilderConfig,
};

export default builderConfig;
